import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

export default new EnumItem({
  NORMAL: { value: 1, text: i18n.gettext('标准合同模板') }
})
